<template>
  <div class="select">
    <div class="header">
      <div
        class="headerContent"
        v-for="(item, index) in label"
        :key="index"
        @click="selectClick(item, index)"
      >
        <div class="headerList">
          <p v-if="item.label == item.value">{{ item.value }}</p>
          <p v-else class="active">{{ item.value }}</p>
          <img src="../assets/images/icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="main" v-show="showMain">
      <div class="mainContent">
        <ul v-if="data">
          <li
            v-for="item in data[type]"
            :class="item == label[headerIndex].value ? 'active' : ''"
            :key="item"
            @click="selectListClick(item)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "selectCom",
  props: {
    label: {
      type: Array,
      default: [],
    },
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showMain: false,
      type: "",
      headerIndex: "",
    };
  },
  methods: {
    selectClick(val, index) {
      this.showMain = true;
      this.headerIndex = index;
      this.type = val.name;
    },
    selectListClick(val) {
      this.showMain = false;
      this.$emit("change", this.type, val);
    },
  },
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}
.select {
  position: relative;
  height: 46px;
  .header {
    display: flex;
    background: #fff;
    padding: 13px 0;
    border-bottom:1px solid #EFEFEF;
    margin-top: 11px;
    .headerContent {
      flex: 1;
      .headerList {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        line-height: 46px;
        p{
          font-size: 14px;
          line-height: 20px;
          color: #666666;
        }
        .active {
          color: #e95506;
        }
        img {
          width: 8px;
          height: 8px;
          margin-left: 5px;
        }
      }
    }
    .headerContent + .headerContent {
      border-left: 1px solid #EFEFEF;
    }
  }
  .main {
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 1000;
    background: #fff;
    width: 100%;
    ul {
      border-top: 1px solid #efefef;
      padding: 0 15px;
      font-size: 13px;
      color: #666666;
      line-height: 43px;
      li{
        list-style:none;
      }
      .active {
        color: #e95506;
        position: relative;
        &::before{
          content: '';
          display: block;
          width: 2px;
          height: 26px;
          position: absolute;
          left: -15px;
          top: 50%;
          margin-top: -13px;
          background: #e95506;
        }
      }
      li + li {
        border-top: 1px solid #efefef;
      }
    }
  }
}
</style>
